import { GET_PROBLEMATIQUES } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_PROBLEMATIQUES] (state, problematiques) {
    state.all = problematiques
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/problematiques.js